import { jsxs as l, jsx as r } from "react/jsx-runtime";
import { Box as s, Skeleton as d, Alert as I, FormControl as F, InputLabel as w, Select as y, ListSubheader as h, MenuItem as c, FormControlLabel as A, Switch as v } from "@mui/material";
import { message as C } from "../../../queries/message/index.js";
import "../../../queries/contact/index.js";
import "../../../queries/calendars/index.js";
import { u as j } from "../../../pointsGraph-DTJju-rA.js";
import "../../../queries/student/index.js";
import "../../../queries/settings/index.js";
import "../../../queries/points/index.js";
import "../../../queries/assessment/index.js";
import "../../../queries/assessment/annotations/index.js";
import "../../../queries/assessment/rubrics/index.js";
import "../../../queries/assessment/qcesubjects/index.js";
import "../../../queries/assessment/extensionrequest/index.js";
import "../../../queries/files/index.js";
import "../../../queries/attendance/index.js";
import "../../../queries/forms/index.js";
import "../../../queries/notifications/index.js";
import "../../../queries/interviews/index.js";
import "../../../queries/notes/index.js";
import "../../../queries/annoucements/index.js";
import "../../../queries/payments/index.js";
import "../../../queries/assessment/analysis/index.js";
import "../../../queries/group/index.js";
import "../../../queries/projects/index.js";
import "../../../queries/courses/index.js";
import "../../../queries/password/index.js";
import { useAuth as D } from "../../../context/auth/index.js";
import { useEffect as M } from "react";
const te = ({ selectedFolderId: t, onFolderSelected: n, onUnreadOnlyChanged: f, unreadOnly: g, newMessageButton: u }) => {
  const { IsImpersonating: p } = D(), { settings: o } = j(), { isPending: b, data: i } = new C.folders.userFolders().ToQuery();
  if (M(() => {
    i && (i.Folders.some((m) => m.ID === t) || i.AdminFolders.some((m) => `af${m.AdminFolderId}` === t) || (i.Folders.length > 0 ? n(i.Folders[0].ID) : n(`af${i.AdminFolders[0].AdminFolderId}`)));
  }, [i, t, n]), b)
    return /* @__PURE__ */ l(s, { sx: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1, flexWrap: "wrap", pb: 2 }, children: [
      /* @__PURE__ */ r(d, { width: 100 }),
      /* @__PURE__ */ r(d, { width: 100 })
    ] });
  const { AdminFolders: a, Folders: x } = i;
  return /* @__PURE__ */ l(s, { sx: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1, flexWrap: "wrap", pb: 2 }, children: [
    p && (o == null ? void 0 : o.impersonationHideInbox) && /* @__PURE__ */ r(I, { sx: { marginBottom: 2 }, severity: "warning", variant: "outlined", children: "Personal messages are hidden while impersonating, these folders will be unavailable in the list" }),
    /* @__PURE__ */ l(s, { sx: { display: "flex", alignItems: "center", gap: 3 }, children: [
      /* @__PURE__ */ l(F, { children: [
        /* @__PURE__ */ r(w, { id: "folder-label", children: "Folder" }),
        /* @__PURE__ */ l(
          y,
          {
            labelId: "folder-label",
            id: "folder",
            value: t,
            label: "Folder",
            onChange: (e) => n(e.target.value),
            children: [
              (!p || !(o != null && o.impersonationHideInbox)) && /* @__PURE__ */ r(h, { children: "My Messages" }),
              x.map((e) => /* @__PURE__ */ r(c, { value: e.ID, children: e.Title }, e.ID)),
              a.length > 0 && /* @__PURE__ */ r(h, { children: "School Notices" }),
              a.length > 0 && a.map((e) => /* @__PURE__ */ r(c, { value: `af${e.AdminFolderId}`, children: e.Title }, `af${e.AdminFolderId}`))
            ]
          }
        )
      ] }),
      t === "1" && /* @__PURE__ */ r(A, { labelPlacement: "end", control: /* @__PURE__ */ r(v, { checked: g, onChange: (e) => f(e.target.checked), size: "small" }), label: "Unread only" })
    ] }),
    u
  ] });
};
export {
  te as MessagingForm
};
//# sourceMappingURL=MessagingForm.js.map
